// extracted by mini-css-extract-plugin
module.exports = {"documents":"_89b4965636--documents--HYj93","link-container":"_89b4965636--link-container--EaJcD","fullwidth":"_89b4965636--fullwidth--tbowj","link":"_89b4965636--link--kINS5"};